// extracted by mini-css-extract-plugin
export var actionButton = "_me-t";
export var buttonContainer = "_me-0";
export var buttonContainer2 = "_me-1";
export var buttonSection = "_me-2";
export var details = "_me-3";
export var dropdownItem = "_me-5";
export var dropdownItemsContainer = "_me-4";
export var fileInput = "_me-r";
export var headerButton = "_me-6";
export var icon = "_me-7";
export var input = "_me-8";
export var macroListItem = "_me-9";
export var mainContent = "_me-a";
export var microText = "_me-b";
export var modal = "_me-w";
export var optionsButton = "_me-c";
export var paperclip = "_me-s";
export var pillContent = "_me-d";
export var preview = "_me-e";
export var preview2 = "_me-f";
export var quillEditor = "_me-q";
export var selectedMacro = "_me-g";
export var sidebar = "_me-h";
export var sidebarHeader = "_me-j";
export var sidebarList = "_me-i";
export var sidebarListItem = "_me-k";
export var sidebarSearch = "_me-l";
export var snoozeDurationWrapper = "_me-v";
export var statusPillContainer = "_me-m";
export var tagsContainer = "_me-n";
export var unselectedMacro = "_me-o";
export var variable = "_me-u";
export var wrapper = "_me-p";